module.exports = __webpack_public_path__ + "img/28a62dea5ead3c102fdfab1852268190.png";